import { useState, FormEvent } from "react";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import { myAxios} from "src/components/common/functions";
import { useUploadStore } from "../main/uploadStore";
import { Form, useNavigate, useParams, useRouteLoaderData } from "react-router-dom";
import { Link } from "react-router-dom";
import { Option } from "./types";
//---------------------------------------------------------------------

export default function TrainingForm(){
    const navigate = useNavigate();
    const { id } = useParams() as { id: string };
    const rawData = useRouteLoaderData("trainings");
    const upload = useUploadStore();
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const training = useRouteLoaderData("trainingDetail");
    const [data, setData] = useState(rawData[id]?.status === "Saved" ? rawData[id] : training);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const onSubmit = async(event: FormEvent) => {
        const form = (event.currentTarget as HTMLElement).closest("form")!;
        if(!form.reportValidity()) return;
        const totalScore = data.questions.length;
        let curScore = 0;
        for(let question of data.questions){
            if(question.multi){
                let thisScore = 1;
                for(let option of question.options){
                    if(option.selected && !option.answer){
                        thisScore = 0;
                    }
                    if(!option.selected && option.answer){
                        thisScore = 0.5;
                    }
                }
                curScore += thisScore;
            }else{
                if(question.options.find((option: Option) => option.selected).answer) curScore++;
            }
        }
        const formData = new FormData();
        const file = new File([
            JSON.stringify(
                {...rawData, [id]: {
                    // ...data, 
                    status: curScore >= data.passScore?"Passed":"Failed", 
                    curScore: curScore, 
                    totalScore: totalScore
                }}
            )
        ], "trainings", { type: "text/plain" });
        formData.append("fileSize", String(file.size));
        formData.append("lastModifiedAt", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
        setShowLoader(true);
        const preRes = await myAxios({ fileName: "trainings/takeTraining.php", formData: formData });
        setShowLoader(false);
        if(!preRes) return;
        upload.setFiles([file]);
        upload.setIds([preRes.data.id]);
        upload.setUrls([preRes.data.url]);
        upload.setShow(true);
        upload.setOnResetCallback(() => {
            navigate("..");
        });
    }
    const onSave = async() => {
        const formData = new FormData();
        const file = new File([
            JSON.stringify({...rawData, [id]: {...data, status: "Saved"}})
        ], "trainings", { type: "text/plain" });
        formData.append("fileSize", String(file.size));
        formData.append("lastModifiedAt", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
        setShowLoader(true);
        const preRes = await myAxios({ fileName: "trainings/takeTraining.php", formData: formData });
        setShowLoader(false);
        if(!preRes) return;
        upload.setFiles([file]);
        upload.setIds([preRes.data.id]);
        upload.setUrls([preRes.data.url]);
        upload.setShow(true);
        upload.setOnResetCallback(() => {
            navigate("..");
        });
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Form method = "post">
            {data.questions?.length?<div className = "my-3">
                <div className = "m-3" style = {{whiteSpace: "pre-wrap"}}>Question {currentQuestionIndex + 1}: {data.questions[currentQuestionIndex].name}</div>
                {data.questions[currentQuestionIndex].options.map((opt : Option, optIndex : number) => <div key = {optIndex} className = "m-3">
                    <span className = "me-3">{opt.name}</span>
                    <input 
                        name = {data.questions[currentQuestionIndex].name}
                        type = {data.questions[currentQuestionIndex].multi?"checkbox":"radio"} 
                        style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                        value = {opt.name} 
                        checked = {opt.selected || false}
                        onChange = {e => {
                            setData({...data, questions:[
                                ...data.questions.slice(0, currentQuestionIndex), 
                                {
                                    ...data.questions[currentQuestionIndex],
                                    options: [...data.questions[currentQuestionIndex].options.slice(0, optIndex).map((opt0 : Option) => ({...opt0, selected: data.questions[currentQuestionIndex].multi?opt0.selected:false})), {...opt, 
                                        selected: e.currentTarget.checked
                                    } , ...data.questions[currentQuestionIndex].options.slice(optIndex + 1).map((opt1 : Option) => ({...opt1, selected: data.questions[currentQuestionIndex].multi?opt1.selected:false}))],
                                    signleAnswer: e.currentTarget.value
                                },
                                ...data.questions.slice(currentQuestionIndex + 1)
                            ]});
                        }}
                    />
                    {data.mode === "Practice" && opt.selected?<span className = "ms-3">
                    {opt.answer?<span className = "text-success">Correct</span>:<span className = "text-danger">Wrong</span>} {opt.comment}
                    </span>:null}
                </div>)}
            </div>:null}
            <div className = "m-3">
            {currentQuestionIndex > 0?<span className = "me-3 btn btn-info" onClick = {() => {
                    setCurrentQuestionIndex(i => i - 1);
                }}>Previous</span>:null}
                {currentQuestionIndex < data.questions?.length - 1?<span className = "btn btn-primary" onClick = {() => {
                    setCurrentQuestionIndex(i => i + 1);
                }}>Next</span>:null}
            </div>
            <div className = "mb-3">
                <Link children = "Close" to = "../.." className = "btn btn-secondary"/>
                {currentQuestionIndex === data.questions?.length - 1?
                <button children = {"Submit"} onClick = {onSubmit} type = "button" className = "btn btn-primary float-end me-3"/>
                :null}
                <button children = {"Savd"} onClick = {onSave} type = "button" className = "btn btn-success float-end me-3"/>
            </div>
        </Form>
    )
}